import React, { createContext, useContext, useState } from 'react';
import AlertDialog from '../components/dialog/AlertDialog';

// Create a context for AlertDialog state
const AlertDialogContext = createContext();

export const useAlertDialog = () => {
  return useContext(AlertDialogContext);
};

export const AlertDialogProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [title, setTitle] = useState('');
  const [type, setType] = useState('alert');
  const [onConfirm, setOnConfirm] = useState(null);
  const [additionalCloseFunction, setAdditionalCloseFunction] = useState(null);

  const showDialog = (
    title,
    message,
    onConfirm,
    additionalCloseFunction = null,
    dialogType = 'alert',
  ) => {
    setTitle(title);
    setMessage(message);
    setType(dialogType);
    setOnConfirm(() => onConfirm);
    setAdditionalCloseFunction(() => additionalCloseFunction);
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
    setMessage('');
    setTitle('');
    setType('alert');
    setOnConfirm(null);
  };

  return (
    <AlertDialogContext.Provider value={{ showDialog, closeDialog }}>
      {children}
      <AlertDialog
        open={open}
        title={title}
        message={message}
        type={type}
        onClose={() => {
          if (typeof additionalCloseFunction === 'function') {
            additionalCloseFunction();
          }
          closeDialog();
        }}
        onConfirm={() => {
          onConfirm && onConfirm();
          closeDialog();
        }}
      />
    </AlertDialogContext.Provider>
  );
};
